module.exports = __webpack_public_path__ + "static/media/Iconfield09.2c1a2785.svg";